"use client";

export default function LandingPage() {
  const projects = [
    {
      title: "Job Landing",
      description: "Scan to view my first project",
      qr: "/job-application.jpeg",
      link: "https://expo.dev/accounts/fiacre_dev/projects/job-application/builds/7314b3d3-1528-41f1-b180-b8854e02141f",
    },
    {
      title: "Foody",
      description: "Scan to explore this project",
      qr: "/foody.jpeg",
      link: "https://expo.dev/accounts/fiacre_dev/projects/foody/builds/b58df458-012d-46c8-a58e-cfd0e095f30c",
    },
    {
      title: "Curbside",
      description: "Scan to access my work",
      qr: "/driver.jpeg",
      link: "https://expo.dev/accounts/fiacre_dev/projects/driver-app/builds/9dbc4fec-c0dc-4340-bf3b-ec0c6b6ae497",
    },
  ];

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6 py-16">

      {/* Header */}
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-green-700">
          Demonstration of my competencies.
        </h1>
        <p className="text-gray-600 mt-3">
          Available for download and installation on Android devices only.
        </p>
      </div>

      {/* Cards */}
      <div className="grid md:grid-cols-3 gap-8 w-full max-w-6xl">

        {projects.map((project, index) => (
          <div
            key={index}
            className="bg-white border-2 border-green-600 rounded-xl shadow-md p-6 flex flex-col items-center text-center transition hover:-translate-y-2 hover:shadow-xl"
          >
            {/* QR Image */}
            <img
              src={project.qr}
              alt={project.title}
              className="w-44 h-44 object-contain mb-4"
            />

            {/* Title */}
            <h3 className="text-xl font-semibold text-green-700">
              {project.title}
            </h3>

            {/* Description */}
            <p className="text-gray-500 text-sm mt-2 mb-4">
              {project.description}
            </p>

            {/* Button */}
            <a
              href={project.link}
              className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 transition"
            >
              Download
            </a>
          </div>
        ))}

      </div>

      {/* Footer */}
      <div className="mt-16 text-gray-400 text-sm">
        © 2026 My Portfolio
      </div>
    </div>
  );
}